/** The only agent available in Reviewed is the AI document editor. */
export type AgentType = "base";
export const AGENT_CONFIGS: Record<AgentType, { displayName: string; streamEndpoint: string; patchesEndpoint: string; minimalChrome?: boolean }> = {
  base: { displayName: "Document editor", streamEndpoint: "/api/document-agent/stream", patchesEndpoint: "/api/document-agent/patches" },
};
